const mapAvailabilityCriterion = criterion => ({
  id: criterion.id,
  internal_id: criterion.internal_id,
  name: criterion.name,
  description: criterion.description,
})

export const transformResponseAvailabilityCriteria = response => ({
  results: response.results.map(mapAvailabilityCriterion),
  count: response.count,
  next: response.next,
})

export const transformRequestReorderAvailabilityCriteria = ({ storeId, criteria }) => ({
  storeId,
  criteria: criteria.map((criterion, index) => ({
    id: criterion.id,
    position: index,
  })),
})
